module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-one.fb8884c3.jpg";